import { render } from "./Coach.vue?vue&type=template&id=4d571744&scoped=true"
import script from "./Coach.vue?vue&type=script&lang=js"
export * from "./Coach.vue?vue&type=script&lang=js"

import "./Coach.vue?vue&type=style&index=0&id=4d571744&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d571744"]])

export default __exports__